export const PIN_CODE_VALUE = '1234'
export const PIN_CODE_ITEMS_LENGTH = 4
export const PIN_CODE_ABSCISSA_REQUIRED_VALUE = 800
export const PIN_CODE_ORDINATE_REQUIRED_VALUE = 400
export const PIN_CODE_REQUIRED_DURATION_MILLISECONDS = 2000
